import { render, staticRenderFns } from "./NbaPositionOpti.vue?vue&type=template&id=ae829f34&scoped=true"
import script from "./NbaPositionOpti.vue?vue&type=script&lang=js"
export * from "./NbaPositionOpti.vue?vue&type=script&lang=js"
import style0 from "./NbaPositionOpti.vue?vue&type=style&index=0&id=ae829f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae829f34",
  null
  
)

export default component.exports